import last from 'lodash/last';

export { showBanner };
window.showBanner = showBanner;
function showBanner(data) {
   if (data && App.intlStoreShowBanner !== false) {
      onDomReady(function() {
         var container = $('main');
         var banner = new Element('div', { html: data.html });

         banner.inject(container, 'top');

         // Google Analytics tracking
         gaStoreTrack($$('.intl-banner')[0], data.salesChannel);

         setupOptionDropdownListener(banner, data.productInfo);
      });
   }
}

/**
 * When the user selects a different product option on the Product Page, and the
 * banner is showing, substitute the old product option URL for the new one.
 */
export { setupOptionDropdownListener };
window.setupOptionDropdownListener = setupOptionDropdownListener;
function setupOptionDropdownListener(banner, productInfo) {
   when($$('.product-option-dropdown .dropdown-wrapper'), function(optionDropdown) {
      optionDropdown.addEvent('valuechanged', function() {
         var optionid = optionDropdown.getValue();
         var optionInfo = productInfo[optionid];

         if (optionInfo) {
            banner.getElement('a').set('href', optionInfo.productURL);
         }
      });
   });
}

// Display a banner to international viewers encouraging them to visit
// one of our other stores. This should show on all store pages except checkout
if (App.showIntlBanner) {
   let dataObject = null;
   if (App.productcode) {
      dataObject = {
         data: { productcode: App.productcode, optionid: App.optionid },
      };
   }

   const param = getURLParameter('country') ? '?country=' + getURLParameter('country') : '';
   const url = 'internal/international_store_promotion' + param;

   new Request.API_2_0(url, {
      onSuccess: function(data) {
         showBanner(data.banner);
      },
   }).send(dataObject);
}

function gaStoreTrack(targetElem, salesChannel) {
   const label = last(new URL(window.location).pathname.split('/'));
   const category = salesChannel + ' Store Banner';
   trackLink(targetElem, category, 'click', label);
}
